/**
 * @generated SignedSource<<7894b0fe11763bb7b04072aee473016c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateImpersonatePersonInput = {
  id: string;
  impersonatePerson?: string | null;
  category?: string | null;
  reason?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateImpersonatePersonMutation$variables = {
  input: UpdateImpersonatePersonInput;
};
export type updateImpersonatePersonMutation$data = {
  readonly UpdateImpersonatePerson: {
    readonly missionControlData: {
      readonly forecastPersons: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly impersonatedPersonId: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type updateImpersonatePersonMutation = {
  variables: updateImpersonatePersonMutation$variables;
  response: updateImpersonatePersonMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MissionControlImpersonatePersonType",
  "kind": "LinkedField",
  "name": "forecastPersons",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impersonatedPersonId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateImpersonatePersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateImpersonatePersonPayload",
        "kind": "LinkedField",
        "name": "UpdateImpersonatePerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateImpersonatePersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateImpersonatePersonPayload",
        "kind": "LinkedField",
        "name": "UpdateImpersonatePerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "65942287a8a1f47c67a5b19d067fe9d1",
    "id": null,
    "metadata": {},
    "name": "updateImpersonatePersonMutation",
    "operationKind": "mutation",
    "text": "mutation updateImpersonatePersonMutation(\n  $input: UpdateImpersonatePersonInput!\n) {\n  UpdateImpersonatePerson(input: $input) {\n    missionControlData {\n      forecastPersons {\n        id\n        firstName\n        lastName\n        impersonatedPersonId\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "113e36804b2177c12d3a8253e69330b2";

export default node;
